import { Injectable } from '@angular/core';
import debug from 'debug';
import * as _ from 'lodash';
import { CrudApiProvider } from '../crud-api/crud-api';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

declare var FileTransfer: any;

export interface UploadData {
  filename: string;
  date: string;
  credential: string;
  policy: string;
  signature: string;
}

@Injectable()
export class MediaFileService {
  log = debug('app:MediaSelector.FileService');

  constructor(public crudApi: CrudApiProvider) {
    this.log('initied');
    window['MediaFileServiceProvider'] = this;
  }

  async uploadAWSDocument(image: string, extension: string) {
    this.log(
      'uploadAWSDocument | going To Get Uploaded Data',
      image,
      extension
    );
    return this.prepDoc(extension)
      .then(async (prepRes) => {
        const uploadData = _.get(prepRes, 'data');
        let awsUpload: any;

        this.log('uploadAWSDocument | upload data', uploadData);

        if (Capacitor.getPlatform() === 'web') {
          this.log('uploadAWSDocument | web', image);
          const savedImageFile = await this.savePictureWeb(image);
          this.log('uploadAWSDocument | saveImageFile', savedImageFile);
          awsUpload = await this.sendDocWeb(
            savedImageFile,
            uploadData,
            extension
          );
        } else {
          awsUpload = await this.sendDoc(image, uploadData, extension);
        }

        this.log('uploadAWSDocument | awsUpload', awsUpload);

        if (awsUpload.url) {
          return awsUpload;
        } else {
          // TODO handle errors correctly
          return 'not found';
        }
      })
      .catch((eprep) => {
        this.log('uploadAWSDocument | error', eprep);
        // TODO handle errors correctly
        return '';
      });
  }

  private async savePictureWeb(photo: any) {
    // Convert photo to base64 format, required by Filesystem API to save
    const base64Data = await this.readAsBase64(photo);

    // Write the file to the data directory
    const fileName = Date.now() + '.jpeg';
    const savedFile = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      // directory: Directory.Data,
    });

    // Use webPath to display the new image instead of base64 since it's
    // already loaded into memory
    return await Filesystem.readFile({ path: savedFile.uri });
  }

  private async readAsBase64(photo: any) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(photo.webPath!);
    const blob = await response.blob();

    return (await this.convertBlobToBase64(blob)) as string;
  }

  private convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });

  async sendDoc(image: string, uploadData: UploadData, extension: string) {
    let awsUri = encodeURI('https://cdllifemobile-uploads.s3.amazonaws.com/'); //dev
    let cdnUrl = 'https://d2z5cdom2mbuj5.cloudfront.net/'; //dev

    try {
      this.log('sendDoc | file', image);
      this.log('sendDoc | UploadData', uploadData);

      var options = {};
      _.set(options, 'fileKey', 'file');
      var time = new Date().getTime();
      var fileName = uploadData.filename;
      _.set(options, 'fileName', fileName);

      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        _.set(options, 'mimeType', 'image/' + extension);
      } else if (
        extension === 'mp4' ||
        extension === 'mpeg-4' ||
        extension === 'avi'
      ) {
        _.set(options, 'mimeType', 'video/' + extension);
      } else if (extension === 'pdf') {
        _.set(options, 'mimeType', 'application/' + extension);
      }
      _.set(options, 'chunkedMode', false);

      var params = {
        key: uploadData.filename,
        acl: 'public-read',
        'Content-Type': _.get(options, 'mimeType') || 'application/pdf',
        'x-amz-credential': uploadData.credential,
        'x-amz-date': uploadData.date,
        'x-amz-algorithm': 'AWS4-HMAC-SHA256',
        policy: uploadData.policy,
        'x-amz-signature': uploadData.signature,
      };
      _.set(options, 'params', params);

      this.log('sendDoc | options', options);
      this.log('sendDoc | params', params);

      this.log('file transfer stuff: ', image, awsUri, options);

      const upload: any = await this.fileTransfer(image, awsUri, options);

      this.log('sendDoc | upload', upload);

      if (upload.responseCode === 204) {
        return {
          url: cdnUrl + uploadData.filename,
          size: upload.bytesSent,
        };
      }

      // return response;
    } catch (err) {
      this.log(err);
    }
  }

  async sendDocWeb(file: any, uploadData: any, extension: string) {
    this.log('sending ', file, uploadData, extension);
    let cdnUrl = 'https://dowgkmhymhtp.cloudfront.net/'; //dev
    let format = '';

    try {
      const data = new FormData();
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        data.append('Content-Type', 'image/' + extension);
        format = 'image';
      } else if (
        extension === 'mp4' ||
        extension === 'mpeg-4' ||
        extension === 'avi'
      ) {
        _.set(data, 'mimeType', 'video/' + extension);
        data.append('Content-Type', 'video/' + extension);
        format = 'video';
      } else if (extension === 'pdf') {
        data.append('Content-Type', 'application/' + extension);
        format = 'pdf';
      }

      data.append('x-amz-credential', uploadData.credential);
      data.append('x-amz-date', uploadData.date);
      data.append('x-amz-algorithm', 'AWS4-HMAC-SHA256');
      data.append('x-amz-signature', uploadData.signature);
      data.append('acl', 'public-read');
      data.append('key', uploadData.filename);
      data.append('policy', uploadData.policy);

      if (file.data) {
        const blob = this.dataURIToBlob('data:image/jpeg;base64,' + file.data);
        data.append('file', blob);
      } else {
        data.append('file', file);
      }

      this.log('sendDocWeb, data', data);

      await this.webFileTransfer(data, cdnUrl);

      return {
        name: file.name,
        format: format,
        fileUrl: cdnUrl + uploadData.filename,
        size: file.size,
      };
    } catch (err) {
      this.log(err);
    }
  }

  dataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  }

  async webFileTransfer(formData: FormData, cdnUrl: string) {
    const res = await fetch(cdnUrl, {
      method: 'POST',
      body: formData,
    });

    return res;
  }

  fileTransfer(image, awsUri, options) {
    return new Promise((resolve, reject) => {
      var ft = new FileTransfer();
      return ft.upload(
        image,
        awsUri,
        (res, e) => {
          resolve(res);
        },
        (res, e) => {
          reject(e);
        },
        options
      );
    });
  }

  prepDoc(extension: string) {
    return this.crudApi.get(`/api/files/security/${extension}`, {
      cachebust: new Date().getTime() + Math.random(),
    });
  }

  async checkFileSystemPermissions() {
    const checkPermissions = await Filesystem.checkPermissions();
    this.log('getDocumentAndUpload | permissions 1', checkPermissions);
    if (!checkPermissions.publicStorage) {
      const requestPermissions = await Filesystem.requestPermissions();
      this.log('getDocumentAndUpload | permissions 2', requestPermissions);
      if (!requestPermissions.publicStorage) {
        return Promise.reject(
          "Android storage permission not granted. Please select 'Allow management of all files' in your app permission settings"
        );
      }
    }
  }

  getMetadata(url): Promise<any> {
    return this.crudApi
      .get('/api/files/metadata', {
        location: url,
      })
      .catch((e) => {
        // stifle
        return {};
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/image-selector/media-file-service.ts